import { reviews } from '@/mocks/reviews';

export default function ReviewSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-accent-700 tracking-wide uppercase whitespace-nowrap">用户口碑</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜群众热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            来看看广大吃瓜群众对51黑料平台的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reviews.map((review, index) => (
            <div
              key={review.id}
              className={`bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 ${
                index >= 4 ? 'opacity-50 grayscale-[30%]' : ''
              }`}
            >
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                  </span>
                ))}
              </div>
              <h4 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug">
                {review.headline}
              </h4>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-4">
                {review.content}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-600">
                    {review.username.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{review.username}</p>
                  <p className="text-xs text-foreground-400">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}